export enum OnyxFormMode {
  ADD = 'add',
  EDIT = 'edit',
}
